export default __webpack_public_path__ + "static/media/282.a6dbf8ef.gif";